import { useCallback, useEffect, useState } from "react";

export interface TDataTelepules {
    "Település": string, 
    "Rövidítés": string
}

export interface TDataSzolgaltato {
    "Rövidítés": string;
    "Teljes név": string;
    "Weblap": string;
    "Hibabejelentő telefonszám": string;
    "Hibabejelentő email cím": string;
    "Hibabejelentő űrlap": string;
}


interface TData {
    telepulesek: TDataTelepules[],
    szolgaltatok: TDataSzolgaltato[],
}


let __DATA : TData;

export function useJsonData() {
    const [isLoaded, setIsLoaded] = useState(false);
    const [telepulesek, setTelepulesek] = useState<TDataTelepules[]>([]);
    const [szolgaltatok, setSzolgaltatok] = useState<TDataSzolgaltato[]>([]);


    useEffect(() => {
        if (__DATA) {
            setTelepulesek(__DATA.telepulesek);
            setSzolgaltatok(__DATA.szolgaltatok);
            setIsLoaded(true);
            return;
        }
        const loader = async () => {
            const response = await fetch('/data/szolgaltatok.json');
            const data = await response.json() as TData;
            console.log(data);
            __DATA = data
            setTelepulesek(data.telepulesek);
            setSzolgaltatok(data.szolgaltatok);
            setIsLoaded(true);
        }
        loader();
    }, []);

    const telepulesByName = useCallback((name: string) => {
        const telep = telepulesek.find(n => n.Település.toUpperCase() == name.toUpperCase());
        return telep;
    }, [telepulesek])

    const szolgaltatoByRovidites = useCallback((rov: string) => {
        const szolg = szolgaltatok.find(n => n.Rövidítés.toUpperCase() == rov.toUpperCase());
        return szolg;
    }, [szolgaltatok])


    return {
        isLoaded,
        telepulesByName,
        szolgaltatoByRovidites,
    }
}